<template>
    <div class="features">
        <h3 class="features-title">{{ __('caption.additionally') }}</h3>
        <div class="features-wrap">
            <a
                :href="propertyAccountingLink"
                class="feature property-accounting"
            >
                <h4 class="feature-title">{{ __('additionboxes.assets.name') }}
                    <span class="feature-price">{{ __('additionboxes.assets.price') }}</span>
                </h4>
                <div class="feature-body">
                    <div class="body-text">
                        {{ __('additionboxes.assets.text') }}
                        <div class="more">{{ __('additionboxes.more_btn') }}</div>
                    </div>
                    <img
                        :src="$mediaPath + require('@/assets/img/boxes.svg')"
                        alt=""
                        class="feature-icon"
                    >
                </div>
            </a>
            <a
                :href="knowledgeBaseLink"
                class="feature knowledge-base"
            >
                <h4 class="feature-title">
                    {{ __('additionboxes.kbase.name') }}
                    <span class="feature-price">{{ __('additionboxes.kbase.price') }}</span>
                </h4>
                <div class="feature-body">
                    <div class="body-text">
                        {{ __('additionboxes.kbase.text') }}
                        <div class="more">{{ __('additionboxes.more_btn') }}</div>
                    </div>
                    <img
                        :src="$mediaPath + require('@/assets/img/book.svg')"
                        alt=""
                        class="feature-icon"
                    >
                </div>
            </a>
        </div>
    </div>
</template>

<script>

export default {
    name: 'AdditionalFeatures',

    data() {
        let prefix = '';

        if (['en', 'es'].includes(this.$localization.lang)) {
            prefix = '/en';
        } else if (this.$localization.lang === 'ru') {
            prefix = '/ru';
        }

        return {
            propertyAccountingLink: prefix + '/capabilities/assets/',
            knowledgeBaseLink: prefix + '/capabilities/knowledge/',
        };
    },
};
</script>

<style lang="sass" scoped>
.features
    max-width: 1135px
    margin: 0 auto
.features-title
  font-size: 22px
  line-height: 32px
  color: #fff
  margin: 40px 0 24px
  text-align: center
.features-wrap
    display: flex
    margin: 0 -8px
.feature
    display: block
    color: #fff
    margin: 0 8px
    border-radius: 20px
    padding: 32px
    width: 50%
.property-accounting
    background: radial-gradient(100% 100% at 50% 100%, rgba(255, 255, 255, 0.36) 0%, rgba(255, 255, 255, 0) 100%), #046A99
.knowledge-base
    background: radial-gradient(100% 100% at 50% 100%, rgba(255, 255, 255, 0.36) 0%, rgba(255, 255, 255, 0) 100%), #7C489C
.feature-title
    font-size: 24px
    line-height: 48px
    font-weight: 700
    margin: 0 0 8px
    .feature-price
        font-weight: 300
        color: #F7F7F7
        opacity: .7
.feature-body
    color: #E6E8EB
    font-size: 14px
    line-height: 21px
    display: flex
    align-items: flex-start
    .body-text
        margin: 0 8px 0 0
    .more
        margin: 24px 0 0
        color: #F7F7F7
        font-weight: 700
        font-size: 16px
        line-height: 24px
        letter-spacing: 0.08em
        text-decoration: underline
        &:hover
            text-decoration: none

@media screen and (max-width: 768px)
    .features-wrap
        display: block
        margin: 0
    .feature
        margin: 0
        width: 100%
        & + .feature
            margin-top: 16px

@media screen and (max-width: 500px)
    .feature-body
        .feature-icon
            max-width: 50px
</style>